$(document).on('interests:destroyed interests:added', () => {
    let $interestForms = $('#interests').find('form');
    if ($interestForms.length) {
        $interestForms.each((index, element) => {
            let ind = index + 1;
            let $interestTitle = $(element).find('legend');
            let titleReplacement = $interestTitle.text().replace(/(\d+)/, `${ind}`);
            $interestTitle.text(titleReplacement);
        });
    }
});